import { MdAllOut, MdDashboard } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";

export const API_URL = process.env.REACT_APP_API_URL;

export const POUCH_BAG_DATA = [
  {
    label: "Enter Counter First Transaction",
    name: "firstTransaction",
  },
  {
    label: "Enter Counter Last Transaction",
    name: "lastTransaction",
  },
  {
    label: "Enter Capture Card as per Journal",
    name: "capturedCardsJournal",
  },
  {
    label: "Enter Actual Capture Card",
    name: "capturedCardsActual",
  },
];

export const NAV_MENU = [
  {
    path: "/dashboard",
    label: "Home",
    icon: BiHomeAlt,
  },
  {
    path: "/deliveries",
    label: "Deliveries",
    icon: MdAllOut,
    subMenu: [
      {
        path: "/delivery-new-requests",
        label: "New Requests",
      },
      {
        path: "/delivery-vault-requests",
        label: "Vault Requests",
      },
      {
        path: "/delivery-pres-area-requests",
        label: "Prep Area Requests",
      },
      {
        path: "/delivery-cashier-assignment",
        label: "Packing Cashier Assignment",
      },
      {
        path: "/delivery-processing-cashier-assignment",
        label: "Processing Cashier Assignment",
      },
      {
        path: "/delivery-vault-handover",
        label: "Vault Handover",
      },
    ],
  },
  {
    path: "/collections",
    label: "Collections",
    icon: MdAllOut,
    subMenu: [
      {
        path: "/collections-new-requests",
        label: "New Requests",
      },
      {
        path: "/collection-cashier-assignment",
        label: "Cashier Assignment",
      },
      {
        path: "/collection-vault-handover",
        label: "Handover cash to vault",
      },
    ],
  },
  {
    path: "/b2b-services",
    label: "B2B",
    icon: MdDashboard,
  },
  {
    path: "/kiosk",
    label: "KIOSK",
    icon: MdDashboard,
    subMenu: [
      {
        path: "/kiosk-stock-requests",
        label: "Stock Requests",
      },
      {
        path: "/kiosk-vault-requests",
        label: "Vault Requests",
      },
      {
        path: "/kiosk-pres-area-requests",
        label: "Prep Area Requests",
      },
      {
        path: "/kiosk-cashier-assignment",
        label: "Cashier Assignment",
      },
    ],
  },
];

export const PREV_DAY_DATE = new Date(
  new Date().setDate(new Date().getDate() - 1)
);

export const MINUTES_IN_MS = 60 * 1000;
export const IDLE_TIMEOUT_MINUTES = 20;
export const IDLE_TIMEOUT = IDLE_TIMEOUT_MINUTES * MINUTES_IN_MS; // 20 minutes
export const CHECK_INTERVAL = 1000; // Check every second

export const OLD_UTC_DATE = Date.UTC(1899, 11, 30);
export const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm A";
